import { render } from "./BugReport.vue?vue&type=template&id=76270cd5"
import script from "./BugReport.vue?vue&type=script&lang=js"
export * from "./BugReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__